import * as actions from "@p81-common/shell-core-js/dist/redux/webRulesSWGGet";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";
import {
  DEFAULT_START_HOUR,
  DEFAULT_END_HOUR,
} from "components/common/Rules/Popups/ManageTime/manageTimeConstants";
import { ffKeys, hasFeatureFlag } from "@p81-common/shell-core-js";
// ------------------------------------
// Action Handlers
// ------------------------------------

// The backend wire shape is a 24-hour { hour, minute }; the UI works in 24h too.
// hour is kept as-is — including 0, which on the Start side means 00:00 and on
// the End side means end of day ("00:00 / End of day"). No AM/PM conversion.
// All Day rules omit startTime/endTime on the wire, so fall back to the form
// defaults to keep the (disabled) time fields populated when toggled off.
function to24h(time, name, defaultHour) {
  const hour = time ? time.hour : defaultHour;
  const minute = time ? time.minute : 0;
  return {
    [`${name}Time`]: hour,
    [`${name}Minutes`]: minute < 10 ? `0${minute}` : `${minute}`,
  };
}

function convertConditionTimes(value) {
  // timezone/allDay/dateRange are DATE_RANGE_CONDITION-only; off => legacy shape.
  const dateRangeFeature = hasFeatureFlag(ffKeys.DATE_RANGE_CONDITION);

  let result = value.map(
    ({ startTime, endTime, weekdays, timezone, allDay, dateRange }) => {
      const converted = {
        weekdays: weekdays.map((weekday) => ({
          label: weekday,
          value: weekday,
        })),
        ...to24h(startTime, "start", DEFAULT_START_HOUR),
        ...to24h(endTime, "end", DEFAULT_END_HOUR),
      };

      if (dateRangeFeature) {
        // Absence == UTC; backfill so existing rules survive a round-trip
        // instead of being flipped to "Local" on save.
        converted.timezone = timezone || "UTC";
        if (typeof allDay === "boolean") {
          converted.allDay = allDay;
        }
        // Backend stores an absolute { startDate, endDate }; UI splits it.
        if (dateRange?.startDate && dateRange?.endDate) {
          converted.dateRangeEnabled = true;
          converted.dateRangeMode = "absolute";
          converted.dateRangeStart = dateRange.startDate;
          converted.dateRangeEnd = dateRange.endDate;
        }
      }

      return converted;
    }
  );
  return result;
}

function prepareValues(data) {
  let { webRules } = data;
  for (let rule of webRules) {
    rule.sources = rule.sources.filter(({ value }) => value?.length > 0);
    rule.destinations = rule.destinations.filter(
      ({ value }) => value?.length > 0
    );
    rule.conditions = rule.conditions.filter(({ value }) => value?.length > 0);

    rule.conditions.forEach((condition) => {
      condition.value = convertConditionTimes(condition.value);
    });
  }
  return data;
}

const ACTION_HANDLERS = {
  [actions.WEB_RULES_SWG_GET_REQUEST]: (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
  }),
  [actions.WEB_RULES_SWG_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: prepareValues(action.data),
  }),
  [actions.WEB_RULES_SWG_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
  [CURRENT_CHILD_ORGANIZATION_SET]: () => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
